import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../common/Button';

interface FormActionsProps {
  onBack?: () => void;
  onSubmit: (e: React.FormEvent) => void;
  isSubmitting: boolean;
  submitLabel?: string;
  submittingLabel?: string;
}

export const FormActions: React.FC<FormActionsProps> = ({
  onBack,
  onSubmit,
  isSubmitting,
  submitLabel,
  submittingLabel,
}) => {
  const { t } = useTranslation('auth');

  return (
    <div className="flex flex-col-reverse md:flex-row md:justify-between gap-4">
      {onBack && (
        <button
          type="button"
          className="font-ambit text-[1.0625rem] not-italic font-[900] leading-[1.5625rem] text-secondary underline underline-offset-auto decoration-solid decoration-auto decoration-skip-ink-none [text-underline-position:from-font]"
          onClick={onBack}
        >
          {t('back')}
        </button>
      )}
      <Button
        variant="primary"
        type="submit"
        className="w-full md:w-auto md:px-8 md:py-2"
        disabled={isSubmitting}
        onClick={onSubmit}
      >
        {isSubmitting
          ? submittingLabel || t('completeProfileCtaSubmitting')
          : submitLabel || t('completeProfileCta')}
      </Button>
    </div>
  );
};
